export const initialValues = {
  firstName: {
    value: "",
    error: "",
    required: true,
    validate: "text",
    minLength: 2,
    maxLength: 80,
    helperText: "Custom error message",
  },
  lastName: {
    value: "",
    error: "",
    required: true,
    validate: "text",
    minLength: 2,
    maxLength: 80,
  },
  email: {
    value: "",
    error: "",
    validate: "email",
  },

  phone: {
    value: "",
    error: "",
    validate: "phone",
    maxLength: 15,
  },
  transactionID: {
    value: "",
    error: "",
    minLength: 3,
    maxLength: 300,
  },
  agreement: {
    value: false,
    error: "",
    required: true,
    validate: "checkbox",
    helperText: "Please accept our terms and conditions",
  },
};
